import Button from '@/shared/Button'
import ThumbUpOffAlt from '@mui/icons-material/ThumbUpOffAlt'
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt'
import Grid from '@mui/material/Grid'

import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const RateIcon = ({ icon, index, onHover, onClick, hovered = false }) => (
  <Box sx={{ flex: 1, mx: { xs: 1, sm: 2 } }}>
    <Box
      sx={{ transform: hovered ? 'scale(1.3)' : 'scale(1)' }}
      onMouseEnter={() => {
        onHover(index)
      }}
      onClick={onClick}
    >
      {icon}
    </Box>
  </Box>
)

const RateSelect = ({ selected = 0, onSelect, title, icon, selectedIcon }) => {
  const [hoverIndex, setHoverIndex] = useState(0)

  const selectedIcons = () => {
    const components = []
    for (let i = 0; i < selected; i += 1) {
      components.push(
        <RateIcon
          key={`selected_${Math.round(Math.random() * 4)}_${i}`}
          index={i}
          icon={selectedIcon}
          onHover={setHoverIndex}
          hovered={i <= hoverIndex}
          onClick={() => {
            onSelect(i + 1)
          }}
        />,
      )
    }

    return components
  }

  const unselectedIcons = () => {
    const components = []
    for (let i = 0; i < 5 - selected; i += 1) {
      components.push(
        <RateIcon
          key={`unselected_${Math.round(Math.random() * 4)}_${i}`}
          index={selected + i}
          icon={icon}
          onHover={setHoverIndex}
          hovered={selected + i <= hoverIndex}
          onClick={() => {
            onSelect(selected + i + 1)
          }}
        />,
      )
    }

    return components
  }

  return (
    <Grid container sx={{ my: 2 }} spacing={2}>
      <Grid xs={12} sm={'auto'} item>
        <Typography sx={{ textAlign: 'center' }}>{title}</Typography>
      </Grid>
      <Grid xs={12} sm={'auto'} item>
        <Box
          display="flex"
          onMouseLeave={() => {
            setHoverIndex()
          }}
        >
          {selectedIcons()}
          {unselectedIcons()}
        </Box>
      </Grid>
    </Grid>
  )
}

const TrainingRateDialog = ({ open, courseCount, onRateSubmit, onNext, onFinish, isLoading }) => {
  const { t } = useTranslation()
  const [rateSelected, setRateSelected] = useState(0)

  return (
    <Dialog open={open}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        {courseCount > 0
          ? t('course.rate_dialog_title', { num: courseCount })
          : t('course.rate_dialog_title_complete')}
      </DialogTitle>
      <DialogContent>
        <RateSelect
          title={t('general.course_rating')}
          icon={<ThumbUpOffAlt color="primary" />}
          selectedIcon={<ThumbUpAlt color="primary" />}
          selected={rateSelected}
          onSelect={setRateSelected}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={'white'}
          loading={isLoading}
          disabled={rateSelected === 0 || isLoading}
          onClick={() => {
            onRateSubmit?.(rateSelected, () => {
              setRateSelected(0)
              onFinish()
            })
          }}
        >
          {t('general.completed')}
        </Button>
        {courseCount && courseCount > 0 ? (
          <Button
            color={'btn_positive'}
            loading={isLoading}
            disabled={rateSelected === 0 || isLoading}
            onClick={() => {
              onRateSubmit?.(rateSelected, () => {
                setRateSelected(0)
                onNext()
              })
            }}
          >
            {t('general.course_next')}
          </Button>
        ) : undefined}
      </DialogActions>
    </Dialog>
  )
}

export default TrainingRateDialog
